export const knight3 = {
  'images': [],
  'mainFeatures': [
    'Nano Graphite Coating with Premium Nature Rubber.',
    'Patented Twin Beams & Claws Structure Lower Down the Height of the Mounting Base.',
    'Patented Multi-functional Mounting Base & Adapters.',
    'Aerodynamic Profile Design for Clear Vision during High-speed Driving.',
  ],
  'material': [
    'Rubber: Premium Nature Rubber.',
    'Steel: SK7',
    'Rivet: Steel Rivet',
    'Plastic: Spacer & Adapter: POM, Spoiler: TPE',
    'Stainless Steel Backing: SUS304ES',
  ],
  'featureIcons': ["11", "02", "03", "04", "07", "10"],
  'otherFeatures': ["01", "02"],
  'specification': [
    { "inch": "13", "mm": "330", "claw": "6", "width": "6", "thickness": "0.7" },
    { "inch": "14", "mm": "350", "claw": "6", "width": "6", "thickness": "0.7" },
    { "inch": "15", "mm": "375", "claw": "6", "width": "6", "thickness": "0.7" },
    { "inch": "16", "mm": "400", "claw": "6", "width": "6", "thickness": "0.8" },
    { "inch": "17", "mm": "425", "claw": "6", "width": "6", "thickness": "0.8" },
    { "inch": "18", "mm": "450", "claw": "8", "width": "6", "thickness": "0.8" },
    { "inch": "19", "mm": "475", "claw": "8", "width": "6", "thickness": "0.8" },
    { "inch": "20", "mm": "500", "claw": "8", "width": "6", "thickness": "0.8" },
    { "inch": "21", "mm": "530", "claw": "8", "width": "6", "thickness": "0.8" },
    { "inch": "22", "mm": "560", "claw": "8", "width": "6", "thickness": "0.8" },
    { "inch": "24", "mm": "600", "claw": "8", "width": "8", "thickness": "0.8" },
    { "inch": "26", "mm": "650", "claw": "8", "width": "8", "thickness": "0.9" },
    { "inch": "28", "mm": "700", "claw": "8", "width": "8", "thickness": "0.9" }
  ],
  'adapters': ['b1', 'b6', 'bl-2a', 'cl+cl-r', "m3", 'm4', 'm5', 'ml', 'ph-3', 'pl', 'pt-3', 'pt6', 'pt-r', 'tl-2', 'tl4a', 'tlc']
}
